import { Sheet, SheetContent, SheetTitle } from "@/components/ui/sheet";

export function MobileDrawer({ open, onOpenChange, children }) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="left" className="p-0 w-72 bg-sidebar border-r border-sidebar-border sm:w-72 flex flex-col h-full focus-visible:outline-hidden">
        <SheetTitle className="sr-only">Navigation Menu</SheetTitle>
        {children}
      </SheetContent>
    </Sheet>
  );
}
